// Tutoriales in-app (#1012/#1013) — llamadas a la API.
import type { AxiosRequestConfig } from "axios";
import api from "../utils/api";
import type { ProgressAction, TutorialProgress, TutorialRules, TutorialsConfig } from "./types";

// El sobre de la API es doble: { meta, data: { message, data } }.
// Las reglas son del USUARIO (su compañía real), no de la compañía que un admin
// de plataforma tenga seleccionada: no se manda company_id.
const userScoped = (signal?: AbortSignal) => ({ signal, _skipCompanyScope: true }) as AxiosRequestConfig;

export async function fetchMyTutorials(
  signal?: AbortSignal,
): Promise<TutorialRules & { progress: TutorialProgress }> {
  const { data } = await api.get("/tutorials/me", userScoped(signal));
  return data.data.data;
}

export async function postProgress(action: ProgressAction, tutorialId?: string): Promise<TutorialProgress> {
  const { data } = await api.post("/tutorials/progress", { action, tutorialId }, userScoped());
  return data.data.data.progress;
}

export async function fetchTutorialsConfig(): Promise<TutorialsConfig> {
  const { data } = await api.get("/tutorials/config");
  return data.data.data;
}

export async function saveTutorialsConfig(
  patch: Partial<Omit<TutorialsConfig, "tutorials">> & {
    tutorials?: Record<string, { enabled?: boolean; audience?: TutorialsConfig["audience"] | null } | null>;
    reason?: string;
  },
): Promise<TutorialsConfig & { changed: boolean }> {
  const { data } = await api.put("/tutorials/config", patch);
  return data.data.data;
}

export interface TutorialsAuditEntry {
  id: string;
  at: string | null;
  by: string | null;
  reason: string | null;
  from: Partial<TutorialsConfig>;
  to: Partial<TutorialsConfig>;
}

export async function fetchTutorialsAudit(): Promise<TutorialsAuditEntry[]> {
  const { data } = await api.get("/tutorials/config/audit");
  return data.data.data || [];
}
